import type { SiteUser } from "@hooks/use-get/users/types";
import type { UserTableColumnFromApi } from "@hooks/use-config-context/user/types";

export const getUserTableData = (
  users: SiteUser[],
  tableColumns: UserTableColumnFromApi[]
): Record<string, any>[] => {
  return users.map((user) => {
    const rowData = tableColumns.reduce<Record<string, any>>((acc, column) => {
      acc[column.id] = column.getValue(user);
      return acc;
    }, {});
    return { ...rowData, id: user.id, wp_user_id: user.wp_user_id };
  });
};
